module.exports = __webpack_public_path__ + "img/danye9.f9b73966.jpg";